import Phaser from 'phaser';

export default class obstacles extends Phaser.Physics.Arcade.Image {
  constructor(scene, x, y, texture, frame) {
    super(scene, x, y, texture, frame);
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.body.setCircle(this.width / 4);
    this.body.setOffset(15, 30);
    this.setOrigin(1);
  }
  update() {
    this.setVelocity(-400, 0);
    if (this.body.position.x < 0) this.destroy();
  }
}
